import { ChakraProvider, Container, Stack } from "@chakra-ui/react";
import React, { FC, useEffect } from "react";

import { ApolloProvider } from "@apollo/client";
import BottomNavigation from "../../organisms/BottomNavigation";
import Breadcrumbs from "../../organisms/Breadcrumbs";
import Footer from "../../molecules/Footer";
import Header from "../../molecules/Header";
import { Helmet } from "react-helmet";
import KlaviyoScript from "../../molecules/Klaviyo";
import SmallResolutionHeader from "../../molecules/Header/SmallResolutionHeader";
import { client } from "../../../../lib/apolloClient";
import theme from "../../../theme/theme";
import { useLocation } from "@reach/router";
import useAuth from "../../useAuth";

type RegularLayoutType = {
  children?: JSX.Element;
  backgroundColor?: string;
  imageHeader?: JSX.Element;
  maxWidth?: any;
  crumbs?: any;
  px?: any;
};

const RegularLayout: FC<RegularLayoutType> = ({
  children,
  backgroundColor,
  imageHeader,
  maxWidth,
  crumbs,
  px,
}) => {
  const shouldApplyMargin = crumbs
    ? { base: "0px" }
    : { base: "60px", lg: "152px" };
  const location = useLocation();
  const siteUrl = "https://www.medsupplysolutions.com";
  const canonicalUrl = `${siteUrl}${location.pathname}`;

  const { loggedIn, user } = useAuth();

  useEffect(() => {
    if (typeof window !== "undefined") {
      // @ts-ignore
      window.dataLayer = window.dataLayer || [];

      // @ts-ignore
      window.dataLayer.push({
        event: "page_view",
        user_id: loggedIn ? user?.id : "guest",
        virual_page_url: window.location.pathname,
      });
    }
  }, [loggedIn, user]);
  return (
    <ApolloProvider client={client}>
      <ChakraProvider theme={theme}>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            background: backgroundColor,
          }}
        >
          <Helmet>
            <html lang="en" />
            <meta charSet="utf-8" />
            <link rel="canonical" href={canonicalUrl} />
            <script>
              {`
                if (window.location.href.indexOf('_ga') > -1 || window.location.href.indexOf('_gl') > -1) {
                  var cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                  if (history.pushState) {
                      window.history.pushState({path:cleanUrl}, '', cleanUrl);
                  } else {
                      window.location.href = cleanUrl;
                  }
              }
              `}
            </script>
            {/* <script
              async
              defer
              type="text/javascript"
              src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Yvk592"
            ></script> */}
          </Helmet>
          <KlaviyoScript />
          {/* <Helmet>
            <script>{`function myInit(){ StampedFn.init({ apiKey: 'pubkey-4l2X92amKnbrzS6022CEoYs2fR62KY', storeUrl: '279010' }); }`}</script> 
            <script async onload="myInit()" type="text/javascript" src="https://cdn1.stamped.io/files/widget.min.js"></script> 
            </Helmet> */}
          <Stack display={{ base: "flex", lg: "none" }}>
            <SmallResolutionHeader />
          </Stack>
          <Stack display={{ base: "none", lg: "flex" }}>
            <Header />
          </Stack>

          <Container
            width="100%"
            flex={1}
            maxWidth={maxWidth ?? "1280px"}
            padding={0}
            mt={shouldApplyMargin}
            mx="auto"
            overflow={"hidden"}
          >
            {crumbs && <Breadcrumbs px={px} crumbs={crumbs} />}

            {imageHeader}
            {children}
          </Container>

          <Stack display={{ base: "flex", lg: "none" }}>
            <BottomNavigation />
          </Stack>
          <Stack mx="auto" alignItems="center" width="100%" bg="#FFF5F7">
            <Footer />
          </Stack>
        </div>
      </ChakraProvider>
    </ApolloProvider>
  );
};

export default RegularLayout;
